let routes = [
  {
    path: '/courriel-formulaire-sref',
    component: () => import('../views/MiseAJourServiceReference.vue'),
    props: true
  }
]

export default routes;